<template>
  <div>
    <!-- <load-profile></load-profile> -->
    <b-tabs
      v-model="activeTabIndex"
      vertical
      content-class="col-12 col-md-9 mt-1 mt-md-0"
      pills
      nav-wrapper-class="col-md-3 col-12"
      nav-class="nav-left"
    >
      <b-tab>
        <template #title>
          <feather-icon icon="LayoutIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">{{
            $t('breadcrumb.widget')
          }}</span>
        </template>
        <update-chat-widget v-if="activeTabIndex === 0" />
      </b-tab>

      <b-tab>
        <template #title>
          <feather-icon icon="BoxIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">{{
            $t('pages.chatSettings.quickMessage.autoMessage')
          }}</span>
        </template>
        <b-card ref="container" id="container" v-if="activeTabIndex === 1">
          <b-card-text class="mb-2">
            <h5>{{ $t("pages.chatSettings.desc") }}</h5>
          </b-card-text>
          <text-editor
            :key="0"
            :id="welcomeMessage.id"
            :title="$t('pages.chatSettings.welcome.title')"
            :desc="$t('pages.chatSettings.welcome.desc')"
            v-model="welcomeMessage.options"
            @update:textEditor="onUpdateTextEditor"
            @update:enable="onUpdateEnable"
            class="mb-2"
          />
          <text-editor
            :key="1"
            :id="replyFirstMessage.id"
            :title="$t('pages.chatSettings.reply.title')"
            :desc="$t('pages.chatSettings.reply.desc')"
            v-model="replyFirstMessage.options"
            @update:textEditor="onUpdateTextEditor"
            @update:enable="onUpdateEnable"
            class="mb-2"
          />
          <text-editor
            :key="2"
            :id="serviceDoesNotAnswer.id"
            :title="$t('pages.chatSettings.serviceUnresponsive.title')"
            :desc="$t('pages.chatSettings.serviceUnresponsive.desc')"
            v-model="serviceDoesNotAnswer.options"
            @update:textEditor="onUpdateTextEditor"
            @update:enable="onUpdateEnable"
            class="mb-2"
          />
          <text-editor
            :key="3"
            :id="customerUnresponsive.id"
            :title="$t('pages.chatSettings.customerUnresponsive.title')"
            :desc="$t('pages.chatSettings.customerUnresponsive.desc')"
            v-model="customerUnresponsive.options"
            @update:textEditor="onUpdateTextEditor"
            @update:enable="onUpdateEnable"
            class="mb-2"
          />
          <text-editor
            :key="4"
            :id="endOfConversation.id"
            :title="$t('pages.chatSettings.endConversation.title')"
            :desc="$t('pages.chatSettings.endConversation.desc')"
            v-model="endOfConversation.options"
            @update:textEditor="onUpdateTextEditor"
            @update:enable="onUpdateEnable"
            class="mb-2"
          />
          <text-editor
            :key="5"
            :id="autoCloseChat.id"
            :title="$t('pages.chatSettings.autoCloseChat.title')"
            :desc="$t('pages.chatSettings.autoCloseChat.desc')"
            v-model="autoCloseChat.options"
            @update:textEditor="onUpdateTextEditor"
            @update:enable="onUpdateEnable"
            class="mb-2"
          />
        </b-card>
      </b-tab>

      <b-tab>
        <template #title>
          <feather-icon icon="ZapIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">{{
            $t('pages.chatSettings.quickMessage.quickMessage')
          }}</span>
        </template>
        <update v-if="activeTabIndex === 2" />
      </b-tab>

      <b-tab>
        <template #title>
          <feather-icon icon="UsersIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">{{
            $t('pages.chatSettings.quickMessage.chatAssignment')
          }}</span>
        </template>
        <chat-assignment v-if="activeTabIndex === 3" />
      </b-tab>

      <b-tab>
        <template #title>
          <feather-icon icon="TerminalIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">{{ $t('breadcrumb.bot') }}</span>
        </template>
        <bot-message v-if="activeTabIndex === 4" />
      </b-tab>

      <b-tab>
        <template #title>
          <feather-icon icon="MessageSquareIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">{{
            $t('breadcrumb.chatSummary')
          }}</span>
        </template>
        <conversation-summary v-if="activeTabIndex === 5" />
      </b-tab>

      <b-tab>
        <template #title>
          <!-- <feather-icon icon="HeadphonesIcon" size="18" class="mr-50" /> -->
          <ChatAgentIcon height="18px" width="18px" />
          <span class="font-weight-bold">{{
            $t('breadcrumb.chatAgent')
          }}</span>
        </template>
        <chat-agent v-if="activeTabIndex === 6" />
      </b-tab>

      <b-tab>
        <template #title>
          <feather-icon icon="LockIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">{{
            $t('breadcrumb.chatPartner')
          }}</span>
        </template>
        <private-chat v-if="activeTabIndex === 7" />
      </b-tab>

      <b-tab>
        <template #title>
          <feather-icon icon="SpeakerIcon" size="18" class="mr-50" />
          <span class="font-weight-bold">{{
            $t('breadcrumb.voiceAlertSettings')
          }}</span>
        </template>
        <speech-alert v-if="activeTabIndex === 8" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  import { BCard, BTab, BTabs, BCardText, BButton } from 'bootstrap-vue';
  import ChatAgentIcon from '@/components/icons/ChatAgentIcon.vue';
  import TextEditor from './components/TextEditor.vue';
  import ChatSettingsRepository from '@/repositories/Api/ChatSettingsRepository';
  import Update from './components/QuickMessage/Update.vue';
  import ChatAssignment from './components/ChatAssignment.vue';
  import SpeechAlert from './components/SpeechAlert.vue';
  import BotMessage from './components/BotMessage.vue';
  import ConversationSummary from './components/ConversationSummary.vue';
  import PrivateChat from '../../views/privateChatIntegration/View.vue';
  import ChatAgent from '../../views/chatAgent/View.vue';
  import UpdateChatWidget from '../chatWidget/Update.vue';

  export default {
    components: {
      BCard,
      BCardText,
      BButton,
      TextEditor,
      BTab,
      BTabs,
      Update,
      ChatAssignment,
      SpeechAlert,
      BotMessage,
      ConversationSummary,
      PrivateChat,
      ChatAgent,
      UpdateChatWidget,
      ChatAgentIcon
    },
    watch: {
      '$i18n.locale'() {
        this.translate();
      },
      '$route.query': {
        immediate: true,
        handler(query) {
          if (query.tab === 'summary') {
            // The summary tab is the last tab (index 5)
            this.activeTabIndex = 5;
          }
        }
      }
    },
    data: () => ({
      data: [],
      activeTabIndex: 0,
      welcomeMessage: {
        id: '',
        title: '',
        desc: '',
        options: {
          enable: false,
          locales: {
            en: 'Welcome',
            zh: '',
            km: '',
            vi: ''
          }
        }
      },
      replyFirstMessage: {
        id: '',
        title: '',
        desc: '',
        options: {
          enable: false,
          locales: {
            en: '',
            zh: '',
            km: '',
            vi: ''
          }
        }
      },
      serviceDoesNotAnswer: {
        id: '',
        title: '',
        desc: '',
        options: {
          sendAfter: 60,
          enable: false,
          locales: {
            en: '',
            zh: '',
            km: '',
            vi: ''
          }
        }
      },
      customerUnresponsive: {
        id: '',
        title: '',
        desc: '',
        options: {
          sendAfter: 60,
          enable: false,
          locales: {
            en: '',
            zh: '',
            km: '',
            vi: ''
          }
        }
      },
      endOfConversation: {
        id: '',
        title: '',
        desc: '',
        editorTitle: '',
        options: {
          enable: false,
          locales: {
            en: '',
            zh: '',
            km: '',
            vi: ''
          }
        }
      },
      autoCloseChat: {
        id: '',
        title: '',
        desc: '',
        editorTitle: '',
        options: {
          enable: false,
          closeTime: 60,
          locales: {
            en: '',
            zh: '',
            km: '',
            vi: ''
          }
        }
      }
    }),
    methods: {
      translate() {
        this.welcomeMessage = {
          ...this.welcomeMessage,
          title: this.$t('pages.chatSettings.welcome.title'),
          desc: this.$t('pages.chatSettings.welcome.desc')
        };
        this.replyFirstMessage = {
          ...this.replyFirstMessage,
          title: this.$t('pages.chatSettings.reply.title'),
          desc: this.$t('pages.chatSettings.reply.desc')
        };
        this.serviceDoesNotAnswer = {
          ...this.serviceDoesNotAnswer,
          title: this.$t('pages.chatSettings.serviceUnresponsive.title'),
          desc: this.$t('pages.chatSettings.serviceUnresponsive.desc')
        };
        this.customerUnresponsive = {
          ...this.serviceDoesNotAnswer,
          title: this.$t('pages.chatSettings.customerUnresponsive.title'),
          desc: this.$t('pages.chatSettings.customerUnresponsive.desc')
        };
        this.endOfConversation = {
          ...this.endOfConversation,
          title: this.$t('pages.chatSettings.endConversation.title'),
          desc: this.$t('pages.chatSettings.endConversation.desc'),
          editorTitle: this.$t(
            'pages.chatSettings.endConversation.editor.title'
          )
        };
        this.autoCloseChat = {
          ...this.autoCloseChat,
          title: this.$t('pages.chatSettings.autoCloseChat.title'),
          desc: this.$t('pages.chatSettings.autoCloseChat.desc'),
          editorTitle: this.$t('pages.chatSettings.autoCloseChat.editor.title')
        };
      },
      async getChatSettings() {
        try {
          const response = await ChatSettingsRepository.show();
          const { data } = response.data;
          this.data = data;
          if (this.data.length == 0)
            await ChatSettingsRepository.createDefaultChatSettings();
          this.welcomeMessage = this.mappingData('action.welcomeReply');
          this.replyFirstMessage = this.mappingData('action.firstReply');
          this.serviceDoesNotAnswer = this.mappingData(
            'action.merchantNoResponse'
          );
          this.customerUnresponsive = this.mappingData(
            'action.visitorNoResponse'
          );
          this.endOfConversation = this.mappingData('action.endManual');
          this.autoCloseChat = this.mappingData('action.end');
        } catch (err) {
          const { data } = err.response;
          const { message } = data;
          if (message === 'error.recordNotFound')
            await this.createDefaultChatSettings();
        }
      },
      async createDefaultChatSettings() {
        try {
          await ChatSettingsRepository.show();
          await this.getChatSettings();
        } catch (err) {
          alert(err);
        }
      },
      async updateChatSettings(payloadUpdate, id) {
        try {
          const response = await ChatSettingsRepository.update(
            payloadUpdate,
            id
          );
        } catch (err) {
          alert(err);
        } finally {
          await this.getChatSettings();
        }
      },
      async onUpdateEnable(event) {
        let payload = {
          enable: event.enable
        };
        this.updateChatSettings(payload, event.id);
      },
      async onUpdateTextEditor(event) {
        let payload = {
          notifySend: event.sendAfter ? event.sendAfter : event.closeTime,
          message: event.locales
        };
        this.updateChatSettings(payload, event.id);
      },
      mappingData(codeAction) {
        let filterData = this.data.filter(item => {
          return item.code == codeAction;
        });
        let settingMsg = filterData[0];
        let response = {
          id: settingMsg.id,
          title: settingMsg.title,
          desc: settingMsg.description,
          options: {
            enable: settingMsg.enable,
            sendAfter: settingMsg.notifySend,
            locales: {
              en: settingMsg.message.en,
              zh: settingMsg.message.zh,
              km: settingMsg.message.km,
              vi: settingMsg?.message?.vi || null
            }
          }
        };
        if (codeAction == 'action.end') {
          delete response.options.sendAfter;
          response.options.closeTime = settingMsg.notifySend;
        } else if (codeAction == 'action.endManual') {
          delete response.options.sendAfter;
        }
        return response;
      }
    },
    mounted() {
      this.translate();
      this.getChatSettings();
    },
    setup() {
      const permissionType = 'chat-settings';
      return { permissionType };
    }
  };
</script>
